var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeAndStorage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1684.51 553.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#b8bcc0;}.cls-3{fill:#ccd6e5;}.cls-4{fill:#8ab3ff;}.cls-5{fill:#343f42;}.cls-6{fill:#588df0;}.cls-13,.cls-15,.cls-29,.cls-30,.cls-39,.cls-41,.cls-7{fill:none;}.cls-7{stroke:#588df0;}.cls-13,.cls-15,.cls-16,.cls-29,.cls-30,.cls-39,.cls-41,.cls-7{stroke-miterlimit:10;}.cls-8{fill:#828282;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}.cls-14,.cls-16{fill:#d0d6e0;}.cls-15,.cls-16{stroke:#343f42;}.cls-17{opacity:0.4;}.cls-18{fill:#4c6161;}.cls-19{fill:#778689;}.cls-20{fill:#ffd458;}.cls-21{fill:#f6b85d;}.cls-22{fill:#f9a65a;}.cls-23{fill:#333233;}.cls-24{fill:#6c7a7b;}.cls-25{fill:#363c48;}.cls-26{fill:#445b5d;}.cls-27{fill:#69777a;}.cls-28{fill:#444344;}.cls-29{stroke:#a3866a;}.cls-30{stroke:#dcb998;}.cls-31{fill:#d6c17a;}.cls-32{fill:#d6ad68;}.cls-33{fill:#c28e53;}.cls-34{fill:#a4743f;}.cls-35{fill:#845e38;}.cls-36{fill:#f2dac5;}.cls-37{fill:#c5a07d;}.cls-38{fill:#dcb998;}.cls-39{stroke:#fdebdd;}.cls-40{fill:#ded6ce;}.cls-41{stroke:#f2dac5;}.cls-42{fill:#6e6964;}.cls-43{fill:#87817d;}.cls-44{fill:#788bb2;}.cls-45{fill:#9aadca;}.cls-46{fill:#6479a6;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Pallet_01a",
    "data-name": "Pallet_01a",
    viewBox: "0 0 293 256.4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M128.89,112.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M162.14,131.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M172.08,104.53"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("image", {
    width: 293,
    height: 172,
    transform: "translate(0 84.4)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "256.44 167.81 150.04 202.38 36.99 137.11 143.39 102.54 256.44 167.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "150.04 202.38 256.44 167.81 256.44 185.81 243.14 190.13 243.14 178.13 209.89 188.93 209.89 200.93 196.59 205.25 196.64 193.28 163.34 204.06 163.34 216.06 150.04 220.38 150.04 202.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "36.99 137.11 36.99 155.11 83.54 181.99 103.49 193.5 136.74 212.7 150.04 220.38 150.04 202.38 36.99 137.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "183.29 197.58 196.59 205.25 196.64 193.28 183.29 197.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "229.84 182.45 243.14 190.13 243.14 178.13 229.84 182.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "46.97 148.87 46.97 154.87 86.87 177.91 86.87 171.91 46.97 148.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "46.97 154.87 53.62 152.71 46.97 148.87 46.97 154.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "100.17 179.58 100.17 185.58 140.07 208.62 140.07 202.62 100.17 179.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "100.17 185.58 106.82 183.42 100.17 179.58 100.17 185.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "143.39 0.55 50.29 30.93 150.04 88.38 242.97 58.04 143.39 0.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "50.29 30.79 150.04 88.38 150.04 196.38 50.08 138.67 50.29 30.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "150.04 88.38 150.43 196.25 243.57 165.99 242.97 58.04 150.04 88.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M83.53,104"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M140,115.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 83.54,
    y1: 49.99,
    x2: 83.54,
    y2: 157.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 116.79,
    y1: 69.18,
    x2: 116.79,
    y2: 177.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 150.04,
    y1: 88.38,
    x2: 150.04,
    y2: 196.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "243.57 165.99 150.04 196.38 50.08 138.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 150.04,
    y1: 142.38,
    x2: 50.29,
    y2: 84.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M130.09,88.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 120.08,
    y1: 8.11,
    x2: 219.83,
    y2: 65.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 73.53,
    y1: 23.24,
    x2: 173.28,
    y2: 80.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "63.59 98.47 76.89 106.14 76.89 118.14 63.59 110.47 63.59 98.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "96.84 117.66 110.14 125.34 110.14 137.34 96.84 129.66 96.84 117.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "130.09 136.86 143.39 144.54 143.39 156.54 130.09 148.86 130.09 136.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "63.59 44.47 76.89 52.15 76.89 64.14 63.59 56.47 63.59 44.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "130.09 82.86 143.39 90.54 143.39 102.54 130.09 94.86 130.09 82.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "96.84 63.66 110.14 71.34 110.14 83.34 96.84 75.67 96.84 63.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 196.59,
    y1: 73.25,
    x2: 196.59,
    y2: 181.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 243.14,
    y1: 112.13,
    x2: 150.04,
    y2: 142.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 243.57,
    y1: 165.99,
    x2: 243.14,
    y2: 58.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "243.14 58.13 143.39 0.55 50.29 30.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 96.84,
    y1: 15.66,
    x2: 196.59,
    y2: 73.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 209.89,
    y1: 38.93,
    x2: 116.79,
    y2: 69.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 176.64,
    y1: 19.74,
    x2: 83.54,
    y2: 49.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "169.99 81.9 176.64 199.74 183.29 197.58 176.64 79.74 169.99 81.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "70.24 24.31 76.89 22.15 176.64 79.74 169.99 81.9 70.24 24.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "216.54 66.77 223.19 184.61 229.84 182.45 223.19 64.61 216.54 66.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "116.79 9.18 123.44 7.02 223.19 64.61 216.54 66.77 116.79 9.18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "LiftPallet_01a",
    "data-name": "LiftPallet_01a",
    viewBox: "0 0 335.74 288.87"
  }, /*#__PURE__*/React.createElement("use", {
    width: 293,
    height: 256.4,
    xlinkHref: "#Pallet_01a"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("image", {
    width: 209,
    height: 139,
    transform: "translate(126.74 149.87)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "173.31 200.82 216.54 225.77 216.54 231.77 166.66 202.98 173.31 200.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "189.94 195.41 223.19 214.61 216.54 222.77 216.54 225.77 173.31 200.82 189.94 195.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "209.89 188.93 233.16 202.37 233.16 208.37 209.89 194.93 209.89 188.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "226.51 183.53 239.48 191.21 236.16 198.29 232.83 202.37 209.89 188.93 226.51 183.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "239.5 176.22 262.78 168.68 276.39 176.33 253.11 183.89 239.5 176.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "216.54 222.77 229.84 230.45 253.11 183.89 239.5 176.22 216.54 222.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "216.54 222.77 216.54 234.77 229.84 242.45 229.84 230.45 216.54 222.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M276.39,176.33l19.95,35.51v9l-66.5,21.61v-12l23.27-46.56Zm-19.95,12.48-19.95,42.48v3L289.69,217v-3l-16.63-30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M309.26,104.94l-43.11,14-3.33,4.08-3.32,13.08,13.3,13.68,3.32,1.92,8.73-2.89,1.25-3.35-3.33-1.92-6.65,2.16s-10-11.81-10-11.76,3.21-10.09,3.21-10.09l40-13-.09,9.06-9.87,18.19-8.71,2.89-1.91,6.52,10.43-3.49,3.52-1,12-20,1.16-14.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "236.49 231.29 236.49 234.29 289.69 217 289.69 214 273.06 183.41 256.44 188.81 236.49 231.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M261.2,228.63a5.09,5.09,0,0,0-4.76-.82l-13.3,4.32a5.67,5.67,0,0,0-3.28,3.82,10.59,10.59,0,0,0,3.57,11.19,5.07,5.07,0,0,0,4.75.82l13.05-4.24a5.62,5.62,0,0,0,3.54-3.9C266,235.9,264.4,230.89,261.2,228.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 245.66,
    cy: 240.04,
    rx: 6.05,
    ry: 8.32,
    transform: "translate(-52.42 69.41) rotate(-14.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M291.12,218.9a5,5,0,0,0-4.76-.81l-13.3,4.32a5.68,5.68,0,0,0-3.28,3.81c-1.23,3.92.37,8.93,3.57,11.19a5.08,5.08,0,0,0,4.76.82l13-4.23a5.58,5.58,0,0,0,3.54-3.91C295.92,226.18,294.33,221.17,291.12,218.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 275.59,
    cy: 230.32,
    rx: 6.05,
    ry: 8.32,
    transform: "translate(-49.02 76.62) rotate(-14.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "256.44 188.81 273.06 198.41 289.69 193 273.06 183.41 256.44 188.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "273.06 198.41 273.06 207.41 263.11 210.73 263.11 231.53 249.79 223.97 249.79 202.97 256.44 188.81 273.06 198.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "289.69 202 273.06 207.41 273.06 198.41 289.69 193 289.69 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "279.71 226.25 279.71 205.25 263.11 210.73 263.11 231.53 279.71 226.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "266.41 188.57 289.42 117.43 296.07 115.27 273.06 192.41 266.41 188.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "299.39 114.19 276.39 191.33 273.06 192.41 296.07 115.27 299.39 114.19"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_01b",
    "data-name": "Interface_01b",
    viewBox: "0 0 69.82 70.2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.97 25.2 69.82 5.76 69.82 50.76 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.97 25.2 0 19.45 0 64.45 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.82 5.76 9.97 25.2 0 19.45 59.85 0 69.82 5.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "17.63 35.77 52.27 24.52 52.2 52.43 17.63 63.67 17.63 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.26,25.89,51.2,51.71,18.62,62.29V36.5L51.26,25.89m2-2.75L16.62,35V65L53.2,53.16l.07-30Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "39.9 33.48 49.87 30.24 49.87 48.24 39.9 51.48 39.9 33.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 38.88,
    x2: 36.57,
    y2: 34.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 44.88,
    x2: 36.57,
    y2: 40.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 50.88,
    x2: 36.57,
    y2: 46.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 56.88,
    x2: 36.57,
    y2: 52.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "54.89 22.61 54.89 52.61 64.86 49.37 64.86 19.37 54.89 22.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.45,31.31a2.72,2.72,0,0,1-2.75-2.82,4.53,4.53,0,0,1,3.06-4.1,3.67,3.67,0,0,1,1.07-.17A2.72,2.72,0,0,1,23.57,27a4.53,4.53,0,0,1-3.06,4.1A3.66,3.66,0,0,1,19.45,31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.94,27.55l-3.2-1.85a1.78,1.78,0,0,0-1.6-.17,3.36,3.36,0,0,0-2.23,3,1.6,1.6,0,0,0,.52,1.25L22,31.84a1.81,1.81,0,0,0,1.44.07A3.35,3.35,0,0,0,25.69,29,1.54,1.54,0,0,0,24.94,27.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 23.46,
    cy: 29.68,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-14.35 28.32) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.42,28.07a2.72,2.72,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.1A3.61,3.61,0,0,1,30.8,21a2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.61,3.61,0,0,1,29.42,28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.92,24.31l-3.21-1.85a1.77,1.77,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.59,1.59,0,0,0,.53,1.25L32,28.6a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-3A1.56,1.56,0,0,0,34.92,24.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 33.44,
    cy: 26.44,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-8.37 34.78) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.49,25.15a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52A4.26,4.26,0,0,1,38.46,25,3.34,3.34,0,0,1,37.49,25.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 38.18,
    cy: 21.9,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-3.24 36.79) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.14,23a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,48,19a4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,44.14,23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 44.83,
    cy: 19.74,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.75 41.1) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.79,20.83a2.4,2.4,0,0,1-2.44-2.52,4.27,4.27,0,0,1,2.85-3.82,3.32,3.32,0,0,1,1-.15,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,50.79,20.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 51.48,
    cy: 17.58,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(4.73 45.4) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,30.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,30.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 26.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.72 55.16) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,39.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,39.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 35.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-6.13 58.33) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,48.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,48.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 44.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-12.99 61.5) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 32.64,
    x2: 63.17,
    y2: 30.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 41.47,
    x2: 63.17,
    y2: 39.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 50.6,
    x2: 63.17,
    y2: 48.44
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Pallet_01b",
    "data-name": "Pallet_01b",
    viewBox: "0 0 292 252.55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M144.05,107.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M110.8,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M100.86,99.74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadow-2",
    "data-name": "shadow",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 85.55)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.45 147.68 122.9 197.59 255.9 154.38 169.45 104.46 36.45 147.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "122.9 197.59 36.45 147.68 36.45 165.68 49.75 173.36 49.75 161.36 73.02 174.79 73.02 186.79 86.32 194.47 86.28 182.5 109.6 195.91 109.6 207.91 122.9 215.59 122.9 197.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "255.9 154.38 255.9 172.38 122.9 215.59 122.9 197.59 255.9 154.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "99.62 190.15 86.32 194.47 86.28 182.47 99.62 190.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "63.05 169.03 49.75 173.36 49.75 161.36 63.05 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "182.75 184.14 182.75 190.14 136.2 205.27 136.2 199.27 182.75 184.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "182.75 190.14 176.1 186.3 182.75 184.14 182.75 190.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "242.6 164.7 242.6 170.7 196.05 185.82 196.05 179.82 242.6 164.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "242.6 170.7 235.95 166.86 242.6 164.7 242.6 170.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "166.12 0.54 242.6 44.7 122.9 83.59 46.42 39.44 166.12 0.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "242.6 44.7 122.9 83.59 122.9 191.59 242.6 152.7 242.6 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "122.9 83.59 122.51 191.46 46.42 147.44 46.42 39.44 122.9 83.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M189.4,99.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M132.91,110.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 202.7,
    y1: 57.66,
    x2: 206.02,
    y2: 164.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 162.8,
    y1: 70.62,
    x2: 166.12,
    y2: 177.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 122.9,
    y1: 83.59,
    x2: 122.9,
    y2: 191.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "46.42 147.44 122.9 191.59 242.6 152.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 122.9,
    y1: 137.59,
    x2: 242.6,
    y2: 98.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M142.85,84.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 186.07,
    y1: 12.06,
    x2: 66.37,
    y2: 50.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 222.65,
    y1: 33.18,
    x2: 102.95,
    y2: 72.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.85 83.11 129.55 87.43 129.55 99.43 142.85 95.11 142.85 83.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "182.75 70.14 169.45 74.46 169.45 86.46 182.75 82.14 182.75 70.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "222.65 57.18 209.35 61.5 209.35 73.5 222.65 69.18 222.65 57.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.85 137.11 129.55 141.43 129.55 153.43 142.85 149.11 142.85 137.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "182.75 124.14 169.45 128.46 169.45 140.46 182.75 136.14 182.75 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "222.65 111.18 209.35 115.5 209.35 127.5 222.65 123.18 222.65 111.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 83,
    y1: 60.55,
    x2: 83,
    y2: 168.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 46.42,
    y1: 96.44,
    x2: 122.9,
    y2: 137.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 46.42,
    y1: 147.44,
    x2: 46.42,
    y2: 39.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "46.42 39.44 166.12 0.54 242.6 44.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 202.7,
    y1: 21.66,
    x2: 83,
    y2: 60.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 86.32,
    y1: 26.47,
    x2: 162.8,
    y2: 70.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 126.22,
    y1: 13.51,
    x2: 202.7,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "106.27 73.99 99.62 190.15 92.97 186.31 99.62 70.15 106.27 73.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "225.97 35.1 219.32 31.26 99.62 70.15 106.27 73.99 225.97 35.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "69.7 52.87 63.05 169.03 56.4 165.2 63.05 49.03 69.7 52.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "189.4 13.98 182.75 10.14 63.05 49.03 69.7 52.87 189.4 13.98"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 292,
    height: 167,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "Pallet_01b-3",
    "data-name": "Pallet_01b",
    viewBox: "0 0 292 252.55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M144.05,107.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M110.8,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M100.86,99.74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadow-3",
    "data-name": "shadow",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 85.55)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.45 147.68 122.9 197.59 255.9 154.38 169.45 104.46 36.45 147.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "122.9 197.59 36.45 147.68 36.45 165.68 49.75 173.36 49.75 161.36 73.02 174.79 73.02 186.79 86.32 194.47 86.28 182.5 109.6 195.91 109.6 207.91 122.9 215.59 122.9 197.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "255.9 154.38 255.9 172.38 122.9 215.59 122.9 197.59 255.9 154.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "99.62 190.15 86.32 194.47 86.28 182.47 99.62 190.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "63.05 169.03 49.75 173.36 49.75 161.36 63.05 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "182.75 184.14 182.75 190.14 136.2 205.27 136.2 199.27 182.75 184.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "182.75 190.14 176.1 186.3 182.75 184.14 182.75 190.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "242.6 164.7 242.6 170.7 196.05 185.82 196.05 179.82 242.6 164.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "242.6 170.7 235.95 166.86 242.6 164.7 242.6 170.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "166.12 0.54 242.6 44.7 122.9 83.59 46.42 39.44 166.12 0.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "242.6 44.7 122.9 83.59 122.9 191.59 242.6 152.7 242.6 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "122.9 83.59 122.51 191.46 46.42 147.44 46.42 39.44 122.9 83.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M189.4,99.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M132.91,110.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 202.7,
    y1: 57.66,
    x2: 206.02,
    y2: 164.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 162.8,
    y1: 70.62,
    x2: 166.12,
    y2: 177.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 122.9,
    y1: 83.59,
    x2: 122.9,
    y2: 191.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "46.42 147.44 122.9 191.59 242.6 152.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 122.9,
    y1: 137.59,
    x2: 242.6,
    y2: 98.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M142.85,84.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 186.07,
    y1: 12.06,
    x2: 66.37,
    y2: 50.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 222.65,
    y1: 33.18,
    x2: 102.95,
    y2: 72.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.85 83.11 129.55 87.43 129.55 99.43 142.85 95.11 142.85 83.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "182.75 70.14 169.45 74.46 169.45 86.46 182.75 82.14 182.75 70.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "222.65 57.18 209.35 61.5 209.35 73.5 222.65 69.18 222.65 57.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.85 137.11 129.55 141.43 129.55 153.43 142.85 149.11 142.85 137.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "182.75 124.14 169.45 128.46 169.45 140.46 182.75 136.14 182.75 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "222.65 111.18 209.35 115.5 209.35 127.5 222.65 123.18 222.65 111.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 83,
    y1: 60.55,
    x2: 83,
    y2: 168.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 46.42,
    y1: 96.44,
    x2: 122.9,
    y2: 137.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 46.42,
    y1: 147.44,
    x2: 46.42,
    y2: 39.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "46.42 39.44 166.12 0.54 242.6 44.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 202.7,
    y1: 21.66,
    x2: 83,
    y2: 60.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 86.32,
    y1: 26.47,
    x2: 162.8,
    y2: 70.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 126.22,
    y1: 13.51,
    x2: 202.7,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "106.27 73.99 99.62 190.15 92.97 186.31 99.62 70.15 106.27 73.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "225.97 35.1 219.32 31.26 99.62 70.15 106.27 73.99 225.97 35.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "69.7 52.87 63.05 169.03 56.4 165.2 63.05 49.03 69.7 52.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "189.4 13.98 182.75 10.14 63.05 49.03 69.7 52.87 189.4 13.98"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overblik"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "0 429.08 161.19 376.71 161.19 248.71 303.05 202.62 303.05 330.62 859.91 149.21 861.59 5.22 0 285.06 0 429.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "0 277.08 0 285.06 861.59 5.22 852.78 0 0 277.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "294.19 325.5 303.05 330.62 303.05 202.62 294.19 205.5 294.19 325.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "498.12 123.24 799.54 297.27 790.71 300.17 489.25 126.12 498.12 123.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "560.18 311.07 569.05 308.19 569.03 188.19 560.11 183.05 560.18 311.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "790.71 444.17 790.71 300.17 489.25 126.12 489.25 270.12 560.18 311.07 560.11 183.05 684.32 254.74 684.32 382.74 790.71 444.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "1287.24 282.83 1296.11 287.95 1296.11 159.95 1287.24 162.83 1287.24 282.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1536 210.01 1536 66.01 657.72 351.38 657.72 495.38 1154.24 334.05 1154.24 206.05 1296.18 159.93 1296.11 287.95 1536 210.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "1536 58.01 648.85 346.26 657.72 351.38 1536 66.01 1536 58.01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager_01",
    "data-name": "Kontor & Lager 01"
  }, /*#__PURE__*/React.createElement("use", {
    width: 335.74,
    height: 288.87,
    transform: "translate(1279.8 355.03) scale(0.64)",
    xlinkHref: "#LiftPallet_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 69.82,
    height: 70.21,
    transform: "translate(1088.91 257.37) scale(0.64)",
    xlinkHref: "#Interface_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(1061.67 282.45) scale(0.64)",
    xlinkHref: "#Interface_02b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1374.62 157.21) scale(0.64)",
    xlinkHref: "#Pallet_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1435.06 192.11) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1374.62 75.91) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1435.06 110.81) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1283.53 188.49) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1343.97 223.39) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(1497.63 226.59) scale(0.64)",
    xlinkHref: "#Pallet_01b-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAndStorage1);
export default __webpack_public_path__ + "static/media/office-and-storage-1.ae997a5ba8a85dc13cedfe21e0d0226f.svg";
export { ForwardRef as ReactComponent };